import { render, staticRenderFns } from "./SharePresentationBar.vue?vue&type=template&id=4f722a29&scoped=true&"
import script from "./SharePresentationBar.vue?vue&type=script&lang=js&"
export * from "./SharePresentationBar.vue?vue&type=script&lang=js&"
import style0 from "./SharePresentationBar.vue?vue&type=style&index=0&id=4f722a29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f722a29",
  null
  
)

export default component.exports